helperClass = window.helperClass || {}

# ==============================================================================
#
# 変換
#
# ==============================================================================
class Substitution
	# --------------------------------------------------------------------------
	# 1byte文字に変換
	# --------------------------------------------------------------------------
	@to1byte : (text)->
		text = text.replace(/[Ａ-Ｚａ-ｚ０-９]/g,(s)->
			return String.fromCharCode(s.charCodeAt(0) - 0xFEE0)
		)
		text = text
			.replace(/[＿]/g,'_')
			.replace(/[ー]/g,'-')
			.replace(/[／]/g,'/')
			.replace(/[＊]/g,'*')
			.replace(/[・]/g,'•')
			.replace(/[：]/g,':')
			.replace(/[；]/g,';')
			.replace(/[〜]/g,'~')
			.replace(/[＝]/g,'=')
			.replace(/[。]/g,'.')
			.replace(/[、]/g,',')
			.replace(/[？]/g,'?')
			.replace(/[＾]/g,'^')
			.replace(/[｜]/g,'|')
		return text

helperClass.Substitution = Substitution

# ==============================================================================
#
# 検証
#
# ==============================================================================
class Varidation
	# --------------------------------------------------------------------------
	# 空であればtrue
	# --------------------------------------------------------------------------
	@empty : (text)->
		return (text.trim() == '')
	# --------------------------------------------------------------------------
	# 空であればtrue
	# --------------------------------------------------------------------------
	@invalidZip : (text)->
		if @.empty(text) then return false
		relacedText = Substitution.to1byte(text)
		val  = /^[0-9]+-?[0-9]+$/.test(relacedText)
		return if val then false else true
	# --------------------------------------------------------------------------
	# 不正なメールアドレス
	# --------------------------------------------------------------------------
	@invalidMail : (text)->
		if @.empty(text) then return false
		val = /^[a-zA-Z0-9.!#$%&'*+\/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*$/.test(text)
		return if val then false else true

helperClass.Varidation = Varidation

# ==============================================================================
#
# 検証
#
# ==============================================================================
class Text
	# --------------------------------------------------------------------------
	# HTMLエスケープ
	# --------------------------------------------------------------------------
	@escapeHTML : (text,excludeBR=false)->
		if excludeBR
			return Text.replaceCRnLFwithBR($('<pre>').text(text).html())
		else
			return $('<pre>').text(text).html()
	# --------------------------------------------------------------------------
	# \r\n を<br>タグに変換
	# --------------------------------------------------------------------------
	@replaceCRnLFwithBR : (text)-> text.replace(/[\n\r]/g,'<br>')

helperClass.Text = Text
# ==============================================================================

window.helperClass = helperClass
